module.exports = __webpack_public_path__ + "img/events.fb8a868c.svg";